import type { ComponentChildren } from 'preact';

interface CardProps {
  children: ComponentChildren;
  className?: string;
  onClick?: () => void;
}

const BASE = 'bg-surface-card rounded-xl p-4';

/**
 * #950: a clickable card is a real `<button>`, so a keyboard user can reach it with Tab and open it with Enter or Space
 * (the car search results used to be a clickable `div`, unreachable without a mouse). A static card stays a `div`.
 */
export function Card({ children, className = '', onClick }: CardProps) {
  if (onClick) {
    return (
      <button
        type="button"
        className={`${BASE} block w-full text-left cursor-pointer hover:bg-surface-alt transition-colors ${className}`}
        onClick={onClick}
      >
        {children}
      </button>
    );
  }
  return <div className={`${BASE} ${className}`}>{children}</div>;
}
